module.exports = __webpack_public_path__ + "img/feature_top_separate.45f295f3.svg";